import React from 'react';
import { proofNote, stats, universities } from '../data/content';
export function ProofBar() {
  return <section className="w-full bg-slate-50 py-14 md:py-20" data-id="element-142" data-mp="ma8ap3vb8xf0">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-143" data-mp="mbt7z190eugk">
        <dl className="grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-144" data-mp="7kj5mxk3k99g">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse" data-id="element-145" data-mp="cicclst857as">
              <dt className="mx-auto mt-1 block max-w-[14rem] text-sm font-semibold text-blue-700" data-id="element-146" data-mp="3uoqm9fkgmv3d">
                {stat.label}
              </dt>
              <dd className="text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl" data-id="element-147" data-mp="3h4epbume8h8">
                {stat.value}
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 border-t border-slate-200 pt-8 text-center" data-id="element-148" data-mp="3psrtlfs3mqx5">
          <p className="text-xs font-bold uppercase tracking-widest text-blue-600" data-id="element-149" data-mp="1j1itngzew1xo">{proofNote}</p>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-3" data-id="element-150" data-mp="1ny0va7zg3k5s">
            {universities.map(university => <li key={university} className="rounded-full bg-white px-4 py-1.5 text-sm font-bold tracking-tight text-slate-800 ring-1 ring-slate-200" data-id="element-151" data-mp="2sclvqod24f95">
                {university}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}